import { BASE_URL_API } from "../../constants";
import { useAuthStore } from "../../stores/useAuthStore";

export const downloadFile = async ({ url, fallbackFilename = null }) => {
    const user = useAuthStore.getState().infos;

    try {
        const response = await fetch(`${BASE_URL_API}${url}`, {
            headers: {
                Authorization: `Bearer ${user?.access}`,
            },
            method: "GET",
            credentials: "include",
        });

        if (!response.ok) {
            const res = await response.json();
            return {
                success: false,
                message: res.message,
            };
        }

        // Récupérer le header Content-Disposition
        const contentDisposition =
            response.headers.get("Content-Disposition") ||
            response.headers.get("content-disposition");

        // Extraire le nom du fichier depuis Content-Disposition
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);

        let filename = fallbackFilename || "export-heures-travaillees.xlsx"; // Nom par défaut
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
        }

        // Télécharger le fichier
        const blob = await response.blob();
        const link = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(objectUrl);
        link.remove();

        return {
            success: true,
            filename,
        };
    } catch (error) {
        console.error("Erreur lors du téléchargement :", error);
        return {
            success: false,
            message: error.message,
        };
    }
};
